import { apiDelete, apiGet, apiPost, apiPut } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import {
  Booking,
  BookingFormData,
  BookingListParams,
  BookingListResponse,
  ApiResponse,
} from '@/constants/types';

class BookingService {
  async list(params: BookingListParams): Promise<BookingListResponse> {
    try {
      const queryParams = new URLSearchParams();
      if (params.sortDir) queryParams.append('sortDir', params.sortDir);
      if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
      if (params.offset !== undefined) queryParams.append('offset', params.offset.toString());
      if (params.search_string !== undefined) queryParams.append('search_string', params.search_string);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.facilityId) queryParams.append('facilityId', params.facilityId);
      if (params.fraternityId) queryParams.append('fraternityId', params.fraternityId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);

      const url = `${API_ENDPOINTS.BOOKINGS.LIST}?${queryParams.toString()}`;
      const response = await apiGet<BookingListResponse>(url, { showLoader: true });
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch bookings');
    }
  }

  async add(data: BookingFormData): Promise<ApiResponse<Booking>> {
    try {
      const response = await apiPost<ApiResponse<Booking>>(
        API_ENDPOINTS.BOOKINGS.ADD,
        data,
        { showLoader: true, backdrop: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to add booking');
    }
  }

  async update(id: string, data: BookingFormData): Promise<ApiResponse<Booking>> {
    try {
      const response = await apiPut<ApiResponse<Booking>>(
        API_ENDPOINTS.BOOKINGS.UPDATE(id),
        data,
        { showLoader: true, backdrop: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update booking');
    }
  }

  async delete(bookingId: string): Promise<ApiResponse> {
    try {
      const response = await apiDelete<ApiResponse>(
        API_ENDPOINTS.BOOKINGS.DELETE,
        { booking_id: bookingId },
        { showLoader: true, backdrop: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to delete booking');
    }
  }
}

export const bookingService = new BookingService();
